import { h } from 'preact'
import TopicModeration from '../../topic-moderation'
import { Topic } from '../../topic-moderation/interfaces'

const ProductUpdateModeration = ({ topic, topicType } : { topic: Topic, topicType: 'productUpdate' }) =>
  <TopicModeration topic={topic} topicType={topicType} />

export default ProductUpdateModeration
